import { InputType } from "components/generators/inputsGenerator";
import { generateOptions } from "helpers/index";
import { IAutocompleteValue } from "components/inputs/Autocomplete/types";
import VALIDATION from "helpers/validation";
import { FilterField } from "layout/TableConstructor/types";
import { ExaminationListQueryVariables } from "@generated/graphql";
import { EXAMINATION_TYPE_TITLE, GRADE_OPTIONS, TRIAL_STATUS_TITLE } from "constants/global";
import typography from "constants/typography.constants";

export type ExaminationFilter = NonNullable<ExaminationListQueryVariables["filter"]>;

export const candidateNumericIdFilter: FilterField<ExaminationFilter> = {
  name: "candidateNumericId",
  label: "ID кандидата",
  type: InputType.TEXT,
  rules: VALIDATION.inn,
  inputType: "number",
  customFilter: (value) => (value ? +value : undefined),
};

export const candidateFullNameFilter: FilterField<ExaminationFilter> = {
  name: "candidateFullName",
  label: "Кандидат",
  type: InputType.TEXT,
  rules: VALIDATION.userName,
};

export const completedAtFilter: FilterField<ExaminationFilter> = {
  name: "completedAt",
  label: "Дата завершения тестирования",
  type: InputType.DATE,
};

export const candidateScoreFilter: FilterField<ExaminationFilter> = {
  name: "candidateScore",
  label: "Результаты",
  type: InputType.TEXT,
  inputType: "number",
  isRange: true,
  customFilter: (value) => (value ? +value : undefined),
};

export const aiGenerationPercentageFilter: FilterField<ExaminationFilter> = {
  name: "aiGenerationPercentage",
  label: typography.testing.table.aiGenerationPercentage,
  type: InputType.TEXT,
  rules: {
    min: {
      value: 0,
      message: typography.rules.min(0),
    },
    max: {
      value: 100,
      message: typography.rules.max(100),
    },
  },
  inputType: "number",
  isRange: true,
  customFilter: (value) => (value ? +value : undefined),
};

// @ts-expect-error ошибок быть не должно, какой-то косяк с типизацией
export const getStatusFilter = (data?: Partial<FilterField<ExaminationFilter>>): FilterField<ExaminationFilter> => ({
  name: "trialStatus",
  label: "Статус тестирования",
  type: InputType.AUTOCOMPLETE,
  options: generateOptions(TRIAL_STATUS_TITLE),
  customFilter: (value: IAutocompleteValue) => value.id,
  ...data,
});

const examinationListBaseFilterFields: FilterField<ExaminationFilter>[] = [
  {
    name: "numericId",
    label: "ID тестирования",
    type: InputType.TEXT,
    rules: VALIDATION.inn,
    inputType: "number",
    customFilter: (value) => (value ? +value : undefined),
  },
  {
    name: "title",
    label: "Название тестирования",
    type: InputType.TEXT,
    rules: VALIDATION.companyName,
  },
  candidateNumericIdFilter,
  candidateFullNameFilter,
  {
    name: "createdAt",
    label: "Дата создания тестирования",
    type: InputType.DATE,
  },
  completedAtFilter,
  getStatusFilter(),
  candidateScoreFilter,
  {
    name: "expectedTimeOfTesting",
    label: "Время прохождения ожидаемое",
    type: InputType.TEXT,
    inputType: "number",
    isRange: true,
    customFilter: (value) => (value ? +value : undefined),
  },
  {
    name: "timeOfTesting",
    label: "Время прохождения реальное",
    type: InputType.TEXT,
    inputType: "number",
    isRange: true,
    customFilter: (value) => (value ? +value : undefined),
  },
  {
    name: "examinationType",
    label: typography.testing.table.type,
    type: InputType.AUTOCOMPLETE,
    options: generateOptions(EXAMINATION_TYPE_TITLE),
    customFilter: (value: IAutocompleteValue) => value.id,
  },
  {
    name: "isRepositoryCheck",
    label: "Проверка репозитория",
    type: InputType.AUTOCOMPLETE,
    options: [
      { id: "true", displayName: "Да" },
      { id: "false", displayName: "Нет" },
    ],
    customFilter: (option: IAutocompleteValue) => option.id === "true",
    limitTags: 1,
  },

  {
    name: "competencyMapTitle",
    label: "Название КК",
    type: InputType.TEXT,
    rules: VALIDATION.competencyMapTitle,
  },
  {
    name: "specialization",
    label: "Специализация",
    type: InputType.TEXT,
    rules: VALIDATION.competencyMapTitle,
  },
  {
    name: "competencesCount",
    label: "Количество компетенций",
    type: InputType.TEXT,
    rules: VALIDATION.inn,
    inputType: "number",
    isRange: true,
    customFilter: (value) => (value ? +value : undefined),
  },
  {
    name: "blocksCount",
    label: "Количество блоков знаний",
    type: InputType.TEXT,
    rules: VALIDATION.inn,
    inputType: "number",
    isRange: true,
    customFilter: (value) => (value ? +value : undefined),
  },
  {
    name: "grades",
    label: "Грейд КК",
    type: InputType.AUTOCOMPLETE,
    options: GRADE_OPTIONS,
    multiple: true,
    limitTags: 1,
    customFilter: (value: IAutocompleteValue[]) => value.map((g) => g.id),
  },
];

export default examinationListBaseFilterFields;
